import { Component, Input, OnChanges } from '@angular/core';
import { EFProduct } from 'pg-lib/models/experience.model';
import { AnalyticsService } from 'pg-lib/services/analytics.service';
import { EFDataService } from 'pg-lib/services/ef-data.service';

@Component({
    selector: 'app-totem-product',
    templateUrl: './totem-product.component.html',
    styleUrls: ['./totem-product.component.scss'],
    standalone: false
})
export class TotemProductComponent implements OnChanges {

    constructor(private efDataService:EFDataService, private analyticsService:AnalyticsService) { }

    @Input() productId:string;

    isLoading = false;
    productData:EFProduct = null;

    ngOnChanges(): void {
        this.isLoading = true;

        this.efDataService.getProductDetail(this.productId).subscribe((data) => {
            this.isLoading = false;
            this.productData = data;

            if(data?.analytics != null) {
                this.analyticsService.sendEvent('showProduct', data.analytics)
            }
        })
    }
}